module.exports = __webpack_public_path__ + "img/soccer.ce604ef6.svg";